module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point2_3-a972d165c64e25d89bdbf512aca87035.jpg";